module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-mitsu.f1babcc2.png";